import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["hubId"];
import UIIcon from 'UIComponents/icon/UIIcon';
import ExternalPortalOnly from '../../accounts/components/ExternalPortalOnly';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import { theme } from 'academy-common-lib/utils/Styling';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BannerContainer = styled.span.withConfig({
  displayName: "ExternalLearningContentBanner__BannerContainer",
  componentId: "sc-1bjk1j3-0"
})(["display:inline-block;font-size:14px;text-transform:uppercase;font-weight:bold;cursor:pointer;"]);
const BannerIcon = styled(UIIcon).attrs({
  name: 'hubspotCertification',
  size: 'medium',
  color: theme.colors.LORAX
}).withConfig({
  displayName: "ExternalLearningContentBanner__BannerIcon",
  componentId: "sc-1bjk1j3-1"
})(["margin-right:4px;transform:translate(-4px,4px);"]);
export const ExternalLearningContentBanner = _ref => {
  let {
      hubId
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(ExternalPortalOnly, {
    portalId: hubId,
    children: /*#__PURE__*/_jsx(UITooltip, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.externalContent.externalCreatorTooltip"
      }),
      children: /*#__PURE__*/_jsxs(BannerContainer, Object.assign({}, props, {
        children: [/*#__PURE__*/_jsx(BannerIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.externalContent.externalCreatorBanner"
        })]
      }))
    })
  });
};
export default ExternalLearningContentBanner;